import * as angular from "angular";
import { ElectionService } from "../services/election.service";

export class ElectionDataProvider {
    private $q: any;
    private $timeout: any;
    private service: ElectionService;

    public elections: any[] | null = null;

    constructor($q: any, ElectionService: ElectionService, $timeout: any) {
        this.$q = $q;
        this.service = ElectionService;
        this.$timeout = $timeout;
    }

    /**
     * returns all of the data
     */
    getAllElections(): Promise<any> {
        const deferred = this.$q.defer();
        if (this.elections === null) {
            this.service.all().then(
                (response: object) => {
                    const json = response["data"];
                    this.elections = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.elections.push(json.data[i]);
                    }
                    deferred.resolve(this.elections);
                },
                (error: object) => {
                    this.elections = [];
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.elections);
        }
        return deferred.promise;
    }

    clearAll(): void {
        this.elections = null;
    }

    electionWithID(elid: string | number): object {
        for (let i = 0; i < this.elections.length; i++) {
            if (this.elections[i].elid == elid) {
                return this.elections[i];
            }
        }
    }

    getElection(elid: string | number): Promise<any> {
        const deferred = this.$q.defer();
        this.service.info({ id: elid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                }
                deferred.reject();
            },
            () => deferred.reject()
        );

        return deferred.promise;
    }

    spliceElection(election: object): void {
        if (this.elections !== null) {
            this.$timeout(() => {
                let index = this.elections.indexOf(election);
                if (index > -1) {
                    this.elections.splice(index, 1);
                }
            });
        }
    }

    removeElection(election: any): Promise<any> {
        const deferred = this.$q.defer();
        this.service.delete({ id: election.elid }).then((response: object) => {
            const json = response["data"];
            if (json.success) {
                this.spliceElection(election);
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    replaceElection(election: any): void {
        this.$timeout(() => {
            let existingElection = this.electionWithID(election.elid);
            if (existingElection) {
                angular.extend(existingElection, election);
            } else {
                this.elections.push(election);
            }
        });
    }

    processSocketUpdate(socketData: object): void {
        if (this.elections) {
            this.replaceElection(socketData);
        }
    }

    processSocketCreate(socketData: object): void {
        if (this.elections) {
            this.replaceElection(socketData);
        }
    }

    processSocketDelete(socketData: any): void {
        if (this.elections) {
            let existingElection = this.electionWithID(socketData.elid);
            if (existingElection) {
                this.spliceElection(existingElection);
            }
        }
    }
}

angular
    .module("vcDataProvider")
    .service("ElectionDataProvider", ElectionDataProvider);
